<template>
  <div class="r-design-customer">
    <div class="basic-list common-flex common-flex-wrap">
      <div v-for="(item, index) in basicList" :key="index">
        <rIpt
          v-if="item.type == 'input'"
          :width="item.width ? item.width + 428 : 428"
          :config="item"
        ></rIpt>
        <rSelect
          v-if="item.type == 'select'"
          :width="428"
          :config="item"
        ></rSelect>
        <rIptText
          v-if="item.type == 'iptText'"
          :width="428"
          :config="item"
        ></rIptText>
        <rAutocomplete
          v-if="item.type == 'autocomplete'"
          :width="428"
          :config="item"
          @change="handleChange"
        >
        </rAutocomplete>
        <rInputSuit
          v-if="item.type == 'iptSuit'"
          :width="428"
          :config="item"
          @changeSuit="handleChangeSuit"
        >
        </rInputSuit>
        <rInputDate v-if="item.type === 'date'" :width="428" :config="item">
        </rInputDate>
      </div>
      <!-- <rIpt :width="428" :config="params.orderMsg"></rIpt> -->
    </div>
  </div>
</template>

<script>
import rIpt from "./r-ipt";
import rSelect from "./r-select";
import rIptText from "./r-ipt-text";
import rAutocomplete from "./r-autocomplete";
import rInputSuit from "./r-input-suit";
import rInputDate from "./r-input-date";
export default {
  components: {
    rIpt,
    rSelect,
    rIptText,
    rAutocomplete,
    rInputSuit,
    rInputDate
  },
  data() {
    return {};
  },
  props: {
    basicList: Array
  },
  methods: {
    handleChangeSuit(item) {
      this.$emit("changeSuit", item);
    },
    handleChange(item) {
      this.$emit("change", item);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-design-customer {
  width: 1360px;
  .basic-list {
    text-align: left;
    > div {
      margin-right: 38px;
      margin-top: 33px;
    }
    > div:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-design-customer.vue